<template>
  <div class="member" style="min-width:1440px;">
    <div class="member_content">
      <div class="container animated fadeInUp">
        <div v-if="chOrEn!='0'" style="width:353px;font-size:64px;color:#FFFFFF;font-weight: bold;text-align:left">准备好</div>
        <div v-else style="width:353px;font-size:64px;color:#FFFFFF;font-weight: bold;text-align:left">Get Ready</div>
        <div v-if="chOrEn!='0'" style="width:600px;font-size:64px;color:#FFFFFF;font-weight: bold;text-align:left;margin-bottom:40px">加入我们吗?</div>
        <div v-else style="width:600px;font-size:64px;color:#FFFFFF;font-weight: bold;text-align:left;margin-bottom:40px">To Join Us?</div>
        <h5 v-if="chOrEn!='0'">请申请单位下载申请表(点击下方下载按钮)</h5>
        <h5 v-else>Please download the Application Document by click the download button (below)</h5>
        <h5 v-if="chOrEn!='0'">并将资料发送至邮箱(<span>{{mailbox}}</span>)</h5>
        <h5 v-else>And send the information to the mailbox(<span>{{mailbox}}</span>)</h5>
        <h5 v-if="chOrEn!='0'">
          依据联盟章程，联盟成员资格对所有具备独立法人资格的雕塑公园开放。
        </h5>
        <h5 v-else style="text-align:left">
          According to the constitution of the alliance, the membership of the alliance is open to all sculpture parks with independent legal personality.
        </h5>
        <h5 v-if="chOrEn!='0'">成员应提交书面申请，经联盟大会决定通过。</h5>
        <h5 v-else>Members should submit a written application, which is approved by the Alliance Assembly.</h5>
        <div class="down_load" style="margin-top:30px;margin-left:284px">
          <a
            :href=aDox
            :download="chOrEn=='1'?'联盟入会申请表.docx':'Alliance Membership Application Form.docx'"
          >
            <!-- <i class="iconfont icon-xiazai"></i> -->
            <!-- <img class="download_img" src="../assets/img/down.png" alt="" /> -->
            <div v-if="chOrEn!='0'" class="button cent">下载申请表</div>
            <div v-else class="button cent">Download  application form</div>
            <!-- <div v-else class="button cent">Download union application form</div> -->
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {email} from '../api/api'
export default {
  name: "member",
  data() {
    return {
      aDox:'',
      chOrEn:sessionStorage.getItem('chOrEn'),
      mailbox:'',
      img:''
    };
  },
  created(){
    let navigationId = {
      "navigationId":"1"
    }
    email({...navigationId}).then(res=>{
      console.log(res)
      this.mailbox=res.data.data.email4Apply
      this.aDox=res.data.data.filepath
    })
  },
  methods: {
   
  },
};
</script>

<style lang="less" scoped>
.cent{
  display: flex;
  justify-content: center;
  align-items: center;
}
.button{
  width: 284px;
  height: 56px;
  background: #F2F7FB;
  color:#333333;
}
.member_content {
  width: 100%;
  height: 880px;
  background: url("../assets/img/lianxiwomen.png") no-repeat;
  background-size: 100% 100%;
  .container {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    height: 100%;
    flex-direction: column;
    color:#FFFFFF;

    h4 {
      text-align: center;
      color: rgba(255, 255, 255, 0.8);
      font-size: 20px;
      line-height: 40px;
    }
    h5 {
      font-size: 18px;
      line-height: 40px;
    }
    .down_load {
      width: 118px;
      // height: 118px;
      // background: rgba(0, 0, 0, 0.4);
      border-radius: 50%;
      margin-bottom: 20px;
      a {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        text-align: center;
        line-height: 100%;
        .iconfont {
          color: rgba(255, 255, 255, 0.7);
          font-size: 50px;
          line-height: 118px;
        }
        .download_img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>